module.exports = __webpack_public_path__ + "Assets/Images/templates/thumbnails/sales-proof-of-concept.png";